export default [
  {
    field: 'primaryAccountKey',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'primaryAccountKey',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
];
